import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import i18next from "i18next";

function CookieConsent() {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = Cookies.get("cookieConsent");
    const referrer = document.referrer;

    console.log("Referrer:", referrer);

    const allowedShopifyPages = [
      "https://alopexia.com/",
      "https://alopexia.com/pages/home",
      "https://alopexia.com/pages/for-men",
      "https://alopexia.com/pages/for-women",
    ];

    const isFromAllowedPage = allowedShopifyPages.some((url) =>
      referrer.startsWith(url)
    );

    if (!consent && !isFromAllowedPage) {
      setShowBanner(true);
      document.body.style.overflow = "hidden";
      document.documentElement.style.overflow = "hidden";
    }

    return () => {
      document.body.style.overflow = "auto";
      document.documentElement.style.overflow = "auto";
    };
  }, []);

  const handleAcceptAll = () => {
    Cookies.set("cookieConsent", "all", { expires: 365 });
    setShowBanner(false);
    document.body.style.overflow = "auto";
  };

  const handleRejectNonEssential = () => {
    Cookies.set("cookieConsent", "essential", { expires: 365 });
    setShowBanner(false);
    document.body.style.overflow = "auto";
  };

  if (!showBanner) return null;

  return (
    <>
      <div className="cookie-overlay" />
      <div className="cookie-banner">
        <div className="cookieGroup">
          <div className="cookie-banner-content">
            <h5>{i18next.t("We value your privacy!")}</h5>
            <p>
              {i18next.t(
                "We use cookies and other technologies to personalize your experience, perform marketing, and collect analytics. Learn more in our"
              )}{" "}
              <a
                href="https://alopexia.com/policies/privacy-policy"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "black", textDecoration: "underline" }}
              >
                {i18next.t("Privacy Policy")}
              </a>
              .
            </p>
          </div>

          <div className="cookies-button-group">
            <button className="accept" onClick={handleAcceptAll}>
              {i18next.t("Accept")}
            </button>
            <button className="reject" onClick={handleRejectNonEssential}>
              {i18next.t("Decline")}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default CookieConsent;
